import React, { useState } from 'react'
import { useEffect } from 'react'
import { getAllMedia, updateMediaSubmission, getMediaDetails } from '../../../services/admin';
import Pagination from '../../../components/tablePagination';
import CopyComponent from "../../../components/copyComponent";
import Checkbox from '../Subcomponents/checkbox';
import { useNavigate, useSearchParams } from "react-router-dom";
import moment from 'moment';
import { setLoading } from "../../../reducer/auth/auth";
import './urlsubmission.css';
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { format, parseISO } from 'date-fns';
import axios from 'axios';



export default function UrlSubmission() {
    const [list, setList] = useState([]);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        url: '',
        screen_name: '',
        level_of_the_medium: '',
        date_since: '',
        listing_page: 'Clients',
        content_type: '',
        recommended_audience: '',
        why_are_you_submitting_this_url: '',
        title: '',
        description: '',
        date_published: '',
        other_reason: '',
        status: ''
    });
    const [urlId, setUrlId] = useState("");
    useEffect(() => {
        getUrlSubmission();

    }, [])

    const getUrlSubmission = async () => {
        try {
            getAllMedia()
                .then((data) => {
                    setList(data.data.data);
                    dispatch(setLoading(false));
                })
                .catch((err) => {
                    console.log(err)
                    dispatch(setLoading(false));
                });
        } catch (error) {
            dispatch(setLoading(false));
            console.error('Error fetching data:', error);
        }
    };
    const navigateEdit = (e, id) => {
        window.renderFirst = false;
        if (e.target.className == "capitalizeMedium") {
            navigate(`/edit/${id.user_id}`);
        }
    };

    const aprroveSend = async (id) => {
        setUrlId(id);
        try {
            getMediaDetails(id)
                .then((data) => {
                    console.log(data.data.status)
                    if (data.data.status) {
                        let meta = data.data.data;
                        setFormData({
                            url: (meta && meta.url && meta.url) || '',
                            screen_name: (meta && meta.medium_screen_name && meta.medium_screen_name) || '',
                            level_of_the_medium: meta.medium_level || '',
                            date_since: (meta && meta.member_since && meta.member_since) || '',
                            content_type: (meta && meta.content_type && meta.content_type) || '',
                            recommended_audience: (meta && meta.recommend_audience && meta.recommend_audience) || '',
                            why_are_you_submitting_this_url: (meta && meta.reason && meta.reason) || '',
                            title: (meta && meta.title && meta.title) || '',
                            status: (meta && meta.status && meta.status) || 0,
                            date_published: (meta && meta.created_at && meta.created_at) || 0,
                            other_reason: (meta && meta.other_reason && meta.other_reason) || '',
                            description: (meta && meta.description && meta.description) || '',
                           listing_page: meta.publishing_platform
                                ? meta.publishing_platform.split(',').map(v => v.trim())
                                : ["Clients"]

                        });
                        window.loadModal2("#URLsubmissiontModal", "show");
                    }
                })
                .catch(() => { });

        } catch (error) {
            console.error('Error fetching data:', error);
            toast.error("Failed to approve URL submission");
        }
    }
    //
    const rejectSend = async (id) => {
        try {
            let body = {
                id: id,
                status: 4
            }
            const data = await updateMediaSubmission(body);
            if (data.data.status) {
                setList(prevList =>
                    prevList.map(item =>
                        item.id === id ? { ...item, status: 4, status_label: 'Never' } : item
                    )

                );
                toast.success("URL submission rejected successfully");
            } else {
                toast.error("Failed to reject URL submission");
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.error("Failed to approve URL submission");
        }
    }
    const formatDateToMMDDYYYY = (dateStr) => {
        if (!dateStr) return "";
        const [year, month, day] = dateStr.split("-");
        return `${month}/${day}/${year}`;
    };
    const handleSubmit = async () => {
        // const normalizedData = {
        //     ...formData,
        //     date_published: formData.date_published
        //         ? formData.date_published.slice(0, 10)
        //         : '',
        // };
 
        try {

            const payload = {
                id : urlId,
                listing_page: Array.isArray(formData.listing_page) && formData.listing_page.length > 0
                    ? formData.listing_page.join(', ')
                    : "",
                title: formData.title,
                description: formData.description,
                status: formData.status,
                date: formData.date_published
                ? formData.date_published.slice(0, 10)
                : '',
            };
            console.log(payload);
            const data = await updateMediaSubmission(payload);
            const statusMap = {
                    0: 'Pending Review',
                    1: 'Approve and Publish',
                    2: 'Save for Later',
                    3: 'Hold',
                    4: 'Never'
                    };
            if (data.data.status) {
                setList(prevList =>
                    prevList.map(item =>
                        item.id === urlId
                            ? {
                                ...item,
                                title: formData.title,
                                date_published: formData.date_published,
                                status :formData.status,
                                status_label: statusMap[formData.status] || 'Never'
                            }
                            : item
                    )
                );
                toast.success("URL submission rejected successfully");
                 window.loadModal2("#URLsubmissiontModal", "hide");
            } else {
                toast.error("Failed to reject URL submission");
                 window.loadModal2("#URLsubmissiontModal", "hide");
            }
        } catch (error) {
            window.loadModal2("#URLsubmissiontModal", "hide");
            console.error('Error submitting form:', error);
            toast.error("Failed to approve URL submission");
        }
    };

const handleCheckboxChange = (e) => {
  const { value, checked } = e.target;

  setFormData((prev) => {
    const currentList = prev.listing_page || [];

    return {
      ...prev,
      listing_page: checked
        ? [...currentList, value] // ✅ Add value
        : currentList.filter((item) => item !== value), // ✅ Remove value
    };
  });
};
    return (

        <>
            <div className="table-box-medium">
                <table className="caseTable">
                    <tbody>
                        <tr className="dark">

                            <th>
                                {" "}
                                <div className="d-flex align-items-center">
                                    {" "}
                                    <span className="scren-name">ID</span>{" "}
                                    {/* <Sorting callApi={filterListMediums} /> */}
                                </div>
                            </th>

                            <th>Title</th>
                            <th>Screen Name</th>
                            <th>Email</th>
                            <th>Reason</th>
                            <th>Date</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                        {list.length > 0 ? (
                            list.map((item) => (
                                <tr

                                    className="innr pointer"
                                >


                                    <td >{
                                        item.id
                                    }
                                    </td>
                                    <td>
                                        {item.title || (item.url_details && item.url_details.title) || '-'}
                                    </td>
                                    <td>
                                        {item.medium_screen_name || '-'}
                                    </td>
                                    <td>
                                        {item.medium_email || '-'}
                                    </td>
                                    <td>
                                        {item.reason || '-'}
                                    </td>
                                    <td>
                                        {item.created_at
                                            ? format(parseISO(item.created_at), 'yyyy-MM-dd')
                                            : '-'}
                                    </td>
                                    <td>
                                        {item.status_label || 'Pending Review'}
                                    </td>
                                    <td>
                                        <div>

                                            <a
                                                type="button"
                                                data-toggle="modal"
                                                data-target="#topicModal"
                                                className="export-btn urlSubmission-btn"

                                                onClick={(e) => aprroveSend(item.id)}
                                            >
                                                Review
                                            </a>
                                            <br />
                                            &nbsp;

                                            <button
                                                onClick={(e) => rejectSend(item.id)}
                                                className="register-medium-confirnation model-close-btn"
                                            >
                                                Decline
                                            </button>
                                        </div>

                                    </td>

                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={6} className="text-center">
                                    No Records Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>


                {/* popup for add Topic  */}

                {/* end topic */}
            </div>
            <div className="popup-accordion popup-accordion-url-submission">
                <div class="modal fade" id="URLsubmissiontModal" role="dialog">
                    <div class="modal-dialog h-unset modal-dialog-preview">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal">
                                    &times;
                                </button>
                            </div>
                            <div class="modal-body">
                                <h4>URL Submission</h4>
                                <div className="fild-popup-row top-row-info">
                                    <h5>Submission Information</h5>
                                    <div>
                                        <label>
                                            <b>URL Submission:</b>{" "}
                                            <a href={formData.url} target="_blank" rel="noopener noreferrer">
                                                {formData.url}
                                            </a>{" "}
                                            <CopyComponent value={formData.url} />
                                        </label>
                                    </div>

                                    <div>
                                        <label><b>Content Type:</b> {formData.content_type}</label>
                                    </div>

                                    <div>
                                        <label><b>Why are you submitting this URL?:</b> {formData.why_are_you_submitting_this_url} {formData.other_reason && ` ( ${formData.other_reason} )`}</label>
                                    </div>

                                    <div>
                                        <label><b>Recommended Audience:</b> {formData.recommended_audience}</label>
                                    </div>

                                    <div>
                                        <label>
                                            <b>Submission Date:</b>{" "}
                                            {formData.date_published
                                                ? format(parseISO(formData.date_published), 'yyyy-MM-dd hh:mm a')
                                                : '-'}
                                        </label>
                                    </div>

                                </div>
                                <hr />
                                <div className="fild-popup-row top-row-info">
                                    <h5>Who Submitted the Link</h5>
                                    <div>
                                        <label><b>Screen Name:</b> {formData.screen_name}</label>
                                    </div>
                                    <div>
                                        <label><b>Approved Medium Level:</b> {formData.level_of_the_medium}</label>
                                    </div>
                                    <div>
                                        <label><b>Member Since:</b> {formData.date_since}</label>
                                    </div>
                                </div>
                                <hr />
                                <form onSubmit={(e) => e.preventDefault()}>
                                    <h5>Admin Action</h5>
                                    <div className="mb-3 row">
                                        <label htmlFor="listing_page" className="col-sm-3 col-form-label">
                                            Status:
                                        </label>
                                        <div className="col-sm-9">
                                            <select
                                                id="listing_page"
                                                name="status"
                                                value={formData.status}
                                                className="form-select"
                                                onChange={(e) =>
                                                    setFormData((prev) => ({ ...prev, status: e.target.value }))
                                                }
                                            >
                                                <option value="0">Pending Review</option>
                                                <option value="1">Approve and Publish</option>
                                                <option value="2">Save for Later</option>
                                                <option value="3">Hold</option>
                                                <option value="4">Never</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="mb-3 row">
                                        <label htmlFor="listing_page" className="col-sm-3 col-form-label">
                                            Where to Publish:
                                        </label>
                                        <div className="col-sm-9">
                                            <div className="mb-3">
                                            

                                                <div className="form-check form-check-inline">
                                                    <input
                                                    type="checkbox"
                                                    id="clients"
                                                    value="clients"
                                                    checked={formData.listing_page && formData.listing_page.includes("clients")}
                                                    onChange={handleCheckboxChange}
                                                    className="form-check-input"
                                                    />
                                                    <label htmlFor="clients" className="form-check-label">Clients</label>
                                                </div>

                                                <div className="form-check form-check-inline">
                                                    <input
                                                    type="checkbox"
                                                    id="mediums"
                                                    value="mediums"
                                                    checked={formData.listing_page && formData.listing_page.includes("mediums")}
                                                    onChange={handleCheckboxChange}
                                                    className="form-check-input"
                                                    />
                                                    <label htmlFor="mediums" className="form-check-label">Mediums</label>
                                                </div>

                                                <div className="form-check form-check-inline">
                                                    <input
                                                    type="checkbox"
                                                    id="general_public"
                                                    value="general public"
                                                    checked={formData.listing_page && formData.listing_page.includes("general public")}
                                                    onChange={handleCheckboxChange}
                                                    className="form-check-input"
                                                    />
                                                    <label htmlFor="general_public" className="form-check-label"
                                                    style={{ whiteSpace: 'nowrap' }} >General Public</label>
                                                </div>
                                                </div>
                                        </div>
                                    </div>

                                    <div className="mb-3 row">
                                        <label htmlFor="title" className="col-sm-3 col-form-label">
                                            Title:
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                id="title"
                                                name="title"
                                                value={formData.title}
                                                className="form-control"
                                                placeholder=""
                                                onChange={(e) =>
                                                    setFormData((prev) => ({ ...prev, title: e.target.value }))
                                                }
                                            />
                                        </div>
                                    </div>

                                    <div className="mb-3 row">
                                        <label htmlFor="date" className="col-sm-3 col-form-label">
                                            Date:
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="date"
                                                id="date_published"
                                                name="date_published"
                                                value={formData.date_published ? formData.date_published.slice(0, 10) : ''}
                                                className="form-control"
                                                max={new Date().toISOString().slice(0, 10)}
                                                onChange={(e) =>
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        date_published: e.target.value,
                                                    }))
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="mb-3 row">
                                        <label htmlFor="description" className="col-sm-3 col-form-label">
                                            Description:
                                        </label>
                                        <div className="col-sm-9">
                                            <textarea
                                                id="description"
                                                name="description"
                                                value={formData.description}
                                                className="form-control"
                                                rows="4"
                                                placeholder=""
                                                onChange={(e) =>
                                                    setFormData((prev) => ({ ...prev, description: e.target.value }))
                                                }
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div className="cancel-btn-sumbit">
                                        <button
                                            type="button"
                                            data-dismiss="modal"
                                            className="cancel-tn"
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            onClick={handleSubmit}
                                            type="button"
                                            // data-dismiss="modal"
                                            className="sumbit-tn url-sumission-btn"
                                        >
                                            Save
                                        </button>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <Pagination
                rowsPerPageOptions={[5, 10, 25]}
                count={totalcount}
                activeTab={"admindetectedTimezones"}
                timezonePage={timezonePage}
                timezonerowsPerPage={timezonerowsPerPage}
                getPaginationData={getPaginationData}
            /> */}


            {/* <div ><PaginatedItems itemsPerPage={5}/></div> */}
            {/* <addNewTopic
                        /> */}
        </>
    )
}
